import script from "./ClaimRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimRow.vue?vue&type=script&setup=true&lang=js"

import "./ClaimRow.vue?vue&type=style&index=0&id=677eb35e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677eb35e"]])

export default __exports__